function Listening(props) {
	return null;
}

export default Listening;
